import { __require as u } from "./_baseMatches.js";
import { __require as f } from "./_baseMatchesProperty.js";
import { __require as p } from "./identity.js";
import { __require as q } from "./isArray.js";
import { __require as m } from "./property.js";
var e, t;
function M() {
  if (t) return e;
  t = 1;
  var i = u(), o = f(), s = p(), a = q(), _ = m();
  function n(r) {
    return typeof r == "function" ? r : r == null ? s : typeof r == "object" ? a(r) ? o(r[0], r[1]) : i(r) : _(r);
  }
  return e = n, e;
}
export {
  M as __require
};
